import { forwardRef } from "react";
import { TextField } from "@mui/material";

const NPasswordField = forwardRef((props, ref) => (
  <TextField
    {...props}
    inputRef={ref}
    type="password"
    onChange={(e) => props.onChange(e.target.value)}
  />
));

export default NPasswordField;
